<template>
  <div>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <b-link :to="{name:'dashboard'}">Admin</b-link>
        </li>
        <li class="breadcrumb-item active" aria-current="page">Registrations</li>
      </ol>
    </nav>
    <h2 class="px-3 float-left">Registrations</h2>

    <download-excel :data="registrations" name="CapPrize2019.xls" class="float-right px-3">
      <b-button variant="outline-primary" size="sm">Download Excel</b-button>
    </download-excel>

    <b-table
      striped
      small
      hover
      footClone
      responsive
      :items="registrations"
      :fields="fields"
      class="registrations"
    >
      <template slot="name" slot-scope="data">
        <router-link
          :to="{ name: 'admin-list-entries', params: { uid: data.item.uid, name: data.item.name, name: data.item.email} }"
          class="link"
        >{{data.item.name}}</router-link>
        <div>
          <router-link
            :to="{ name: 'admin-list-entries', params: { uid: data.item.uid, name: data.item.name, name: data.item.email} }"
            class="link small"
          >{{data.item.uid}}</router-link>
        </div>
      </template>
      <template slot="entriesStarted" slot-scope="data">
        <span>{{data.item.entriesStarted? data.item.entriesStarted : '0'}}</span>
      </template>
      <template slot="photosUploaded" slot-scope="data">
        <span>{{data.item.photosUploaded? data.item.photosUploaded : '0'}}</span>
      </template>
      <template slot="entriesCompleted" slot-scope="data">
        <span>{{data.item.entriesCompleted? data.item.entriesCompleted : '0'}}</span>
      </template>
    </b-table>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      fields: [
        { key: 'name', sortable: true },
        { key: 'email', sortable: true },
        /*
        { key: 'lastSignIn', sortable: true },
        { key: 'created', sortable: true },
        */
        { key: 'entriesStarted', sortable: true },
        { key: 'photosUploaded', sortable: true },
        { key: 'entriesCompleted', sortable: true }
      ]
    }
  },
  computed: {
    ...mapGetters({
      registrations: 'admin/registrations'
    })
  }
}
</script>

<style>
div.registrations.table-responsive [aria-colindex='1'] {
  padding-left: 1em;
}
.download {
  cursor: pointer;
}
</style>
